var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-1"},[_c('v-progress-linear',{attrs:{"value":_vm.status.completion_percent || _vm.status.percentage,"color":_vm.color,"rounded":"","height":"15"}}),_c('p',{staticClass:"mb-0 mt-1 text-center text--xs"},[_vm._v(_vm._s(_vm.status.name)+" ("+_vm._s(_vm.status.completion_percent || _vm.status.percentage)+"%)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }